import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AbstractControl, Validators, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../loader/loader.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { DomainManagerService } from '../service/domain-manager.service';
import {
  PageChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import {
  process,
  State,
  SortDescriptor,
  GroupDescriptor,
} from '@progress/kendo-data-query';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { whitespace } from '../common/whitespace';
import { Observable, Subject, firstValueFrom, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { APP_DATE_FORMATS } from '../service/date.adapter';
import { EncryptionService } from '../service/encryption.service';
import Validation from '../setting/conform-pass.validator';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MapService } from '../service/map.service';
import { AuthService } from '../service/auth.service';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { environment } from 'src/environments/environment';
import { SubscriptionPlanType } from '../common/enums/subscription-plan.enum';


interface AddOnDetail {
  Id: number;
  AddOnDate: string;
  AddOnCount: number;
  TypeName?: string;
  ExpiryDate?: string;
  AddOnTypes?: {
    TypeName: string;
  };
  addonUsage?: number | string;
}

interface PlanTransaction {
  Id: number;
  TransactionTypeId: number;
  TransactionExpiryDate: string;
  Date: string;
  PlanName: string;
  SubscriptionPlanId: number;
  TransactionStatus: boolean;
  daysRemaining?: number;
  addOns?: AddOnDetail[];
  whatsappStatus?: 'Active' | 'Expired' | null;
  whatsAppExpiryDate: string;
  UsageOverview?: {
    TotalAddonUsers: number;
    TotalPatients: number;
    TotalLocations: number;
    TotalStorage: number;
  }
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ],
  standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  kendoLoading = false;
  public gridData: any;
  keyWordList: any = [
    { text: "KeyWord Replace with Subject Name", id: "[SUBJECT_NAME]" },
    { text: "KeyWord Replace with Client Name", id: "[CLIENT_NAME]" },
    { text: "KeyWord Replace with Domain Name", id: "[DOMAIN_NAME]" },
    { text: "KeyWord Replace with Support Name", id: "[SUPPORT_NAME]" },
    { text: "KeyWord Replace with Contact Number", id: "[CONTACT_NUMBER]" },
    {
      text: "KeyWord Replace with Regards Name",
      id: "[REGARDS_NAME]",
    },
  ];
  @ViewChild("grid", { static: true }) gridKendo: GridComponent;
  @ViewChild(EditorComponent, { static: false })
  kendoEditor: any = EditorComponent;
  @ViewChild('closeModal') closeModal: any;
  @ViewChild('mailCountModal') mailCountModal: any;
  @ViewChild("changePLanConfirmationDialog", { static: true }) changePLanConfirmationDialog!: TemplateRef<any>;
  @ViewChild("changeResetPasswordDialog", { static: true }) changeResetPasswordDialog!: TemplateRef<any>;
  @ViewChild("planLimitDialog") planLimitDialog: TemplateRef<any>;
  @ViewChild("creditLimitDialog") creditLimitDialog: TemplateRef<any>;
  @ViewChild("creditRuleDialog") creditRuleDialog: TemplateRef<any>;
  public kendoGridLoading = false;
  public kendoData: any;
  public groups: GroupDescriptor[] = [];
  state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
    group: this.groups,
  };
  public pageableWithAll: any = {
    pageSizes: [5, 10, 20, 50, 100, 'All']
  };
  public sort: SortDescriptor[] = [];
  searchString: any = '';
  columnList: any = [];
  filterArray: any = [];
  filetrColumn: any = [];
  textboxValue: any = [];
  datePickerValue: any = [];
  selectedRecord: any;
  formValue!: FormGroup;
  updateItem: any;
  allAdminData: any = [];
  showAdd!: boolean;
  showbtn!: boolean;
  emailerror: boolean = false
  isDisabled: boolean = false;
  isDisableUpdate: boolean = false;
  onEditChangeStatus: boolean = false;
  hideTemplateId: any
  p: number = 1;
  total: number = 0;
  remainingCreditLimit: number = 0;
  toppingList = [
    'Extra cheese',
    'Mushroom',
    'Onion',
    'Pepperoni',
    'Sausage',
    'Tomato',
  ];
  currencyList: any = [];
  dropdownValues = [
    { text: 'Registered', value: 'Registered' },
    { text: 'OTP Verified', value: 'OTPVerified' },
    { text: 'Logged In', value: 'LoggedIn' },
  ];
  public templateBody: string = '';
  public Body: string = '';
  matDialogRef!: MatDialogRef<any>;
  confirmationDialog!: MatDialogRef<any>;
  deletedData: any;
  domain: any;
  IsDisable: boolean = false;
  DateFormat: string | undefined;
  companyId = 0;
  status: any;
  selectedCompanyId: any;
  selectedData: any = [];
  createMailForm!: FormGroup;
  addMailForm!: FormGroup;
  clientData: any[] = [];
  public isChecked = false;
  public value: any = [];
  public subject: string = '';
  public Name: string = '';
  TotalEmails: any;
  TotalSendEmails: any;
  TotalUnSendEmails: any;
  CompantData: any = [];
  public isShow = false;
  isInputFieldEmpty: boolean = true;
  isTemplateInputFieldEmpty: boolean = true;
  templateData: any;
  TemplateId: any;
  EmailData: any;
  Id: any;
  templateName: any;
  IsTemplateColor = true;
  IsTemplateClose: boolean = true;
  IsDoctor: boolean = false;
  IsTest: boolean = false;
  screenWidth: number;
  ClientColumnWidth: number = 150;
  TableName = "Client Details";
  SubscriptionPlanType = SubscriptionPlanType;
  displayColumns: any;
  auto: number;
  gridHeight: number;
  screenHeight: number;
  addOns: { id: number, name: string; quantity: number; price: number; previousQuantity: number; }[] = [];
  originalAddOns = [
    { id: 1, name: 'User', price: 500, previousQuantity: 0 },
    { id: 2, name: 'Location', price: 500, previousQuantity: 0 },
    { id: 3, name: 'Patients', price: 500, previousQuantity: 0 },
    { id: 4, name: 'Storage', price: 500, previousQuantity: 0 }
  ];
  plans: {
    id: number,
    name: string;
    monthlyPrice: string;
    annualPrice: string;
    prices?: { [key: string]: { monthly: string; annual: string } };
    isShowAddOn: boolean,
    expriyDate: any
  }[] = [];
  selectedPlanId: number = 0;
  isPlanYearly: boolean = false;
  planPrices: any = {
    [SubscriptionPlanType.BasicPlan]: { INR: { monthly: '0', annual: '0' }, USD: { monthly: '0', annual: '0' } },
    [SubscriptionPlanType.StandardPlan]: { INR: { monthly: '999', annual: '829' }, USD: { monthly: '12', annual: '10' } },
    [SubscriptionPlanType.PremiumPlan]: { INR: { monthly: '2499', annual: '2075' }, USD: { monthly: '28', annual: '23' } },
    [SubscriptionPlanType.EnterprisePlan]: { INR: { monthly: '-', annual: '-' }, USD: { monthly: '-', annual: '-' } }
  };
  newPlan: any;
  ipAddress: any;
  whatsappForm!: FormGroup;
  locationList: { Id: number; Name: string }[] = [];
  isWhatsappSubmitted: boolean = false;
  today = new Date();
  expiryDate: any;
  selectedTemplate: any;
  hideConfirmPassword: boolean = true;
  hideNewPassword: boolean = true;
  form!: FormGroup;
  loading: boolean = false;
  selectedUser: any;
  planLimitForm!: FormGroup;
  creditLimitForm!: FormGroup;
  IsReleaseNote: boolean = false;
  isMaximized = false;
  originalOverlayStyle: Partial<CSSStyleDeclaration> = {};
  originalDialogStyle: Partial<CSSStyleDeclaration> = {};
  isMaximizedEmail = false;
  originalOverlayStyleEmail: Partial<CSSStyleDeclaration> = {};
  originalDialogStyleEmail: Partial<CSSStyleDeclaration> = {};
  previousPlan: PlanTransaction[] = [];
  currentPlan: PlanTransaction | null = null;
  activeTab: number = 0;
  PanelBarExpandMode = PanelBarExpandMode
  selectedCurrencyId: number;
  currencyMap: any = [];
  isSendInvoice: boolean = true;
  isRadiologyDomain: boolean = false;
  private readonly destroy$ = new Subject<void>();
  isAIEnabled: boolean = false;
  usageOverviewData: any[] = [];
  private readonly aiKeyName: string = 'AIChatEnable';
  creditRuleForm!: FormGroup;

  constructor(
    private readonly FormBuilder: FormBuilder,
    private readonly api: ApiService,
    private readonly toaster: ToastrService,
    private readonly LoaderService: LoaderService,
    private readonly dialog: MatDialog,
    public datePipe: DatePipe,
    private readonly router: Router,
    private readonly cd: ChangeDetectorRef,
    private readonly encryptionService: EncryptionService,
    private readonly overlayContainer: OverlayContainer,
    private readonly mapService: MapService,
    private readonly authService: AuthService,
    private readonly domainService: DomainManagerService
  ) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  ngOnInit(): void {
    const currentUrl = this.router.url.toLowerCase();

    if (this.authService.isAuthenticated()) {
      if (!currentUrl.includes('user') && !currentUrl.includes('client')) {
        this.router.navigate(['/dashboard']);
      }
    }
    this.formValue = this.FormBuilder.group({
      FirstName: ['', [Validators.required, whitespace]],
      CompanyName: [''],
      Salutation: [''],
      Email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'),
          whitespace,
        ],
      ],
      PhoneNumber: ['', [Validators.required, whitespace]],
      CompanyAddress: ['', [Validators.required, whitespace]],
      CurrencyId: ['', Validators.required],
      IsActive: [true],
      IsTestAccount: [false]
    });

    this.formInIt();
    const container = this.overlayContainer.getContainerElement();
    container.style.zIndex = '2000';
    this.emailInit()
    this.getCountry()
    this.whatsappFormInit();
    this.resetInit();
    this.IsTest = this.domainService.isTestDomain;
    this.isRadiologyDomain = this.domainService.isRadiologyDomain;
    this.getDomain();
    this.setGridHeight();

    setTimeout(() => {
      if (!localStorage.getItem("IA")) {
        this.api.getIPAddress().subscribe((x: any) => {
          const ipAddress = x.ip;
          this.ipAddress = ipAddress;
          localStorage.setItem("IA", this.ipAddress);
        });
      } else {
        this.ipAddress = localStorage.getItem("IA");
      }
    }, 200);
    this.getAllNewTemplate();
    this.planLimitInit();
    this.creditLimitInit();
    this.getCurrency();
    this.creditRuleInit();
  }
  public get isIndet() {
    return (
      this.value.length !== 0 && this.value.length !== this.clientData.length
    );
  }
  private loadData(): void {
    this.gridData = process(this.allAdminData, this.state);
    this.gridData = {
      data: this.allAdminData,
      total: this.total,
    };
  }
  public dataStateChange(state: any): void {
    this.state = state;
    this.getDomain();
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.getDomain();
  }
  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.state.take = event.take;
    this.getDomain();
  }
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.getDomain();
  }
  getCountry() {
    this.api.getCountry().subscribe((res) => {
      if (res.Success) {
        this.currencyList = res['Data'];
      }
    })
  }

  public handleBlurEmail(_controlName: any) {
    let oldEmail = this.updateItem.Email;
    let matchEmailValue = this.formValue.value.Email;
    this.api.matchEmailName(matchEmailValue).subscribe((res: any) => {
      if (matchEmailValue === oldEmail) {
        this.emailerror = false;
      } else if (res.ResponseCode === 404) {
        this.emailerror = true;
      } else {
        this.emailerror = false;
      }
    });
  }

  addMigration() {
    this.IsDisable = true;
    this.LoaderService.show();
    this.api.addMigration().subscribe({
      next: (_res) => {
        this.toaster.success('All Migration Run Successfully..');
        this.matDialogRef.close();
        this.LoaderService.hide();
        setTimeout(() => {
          this.IsDisable = false;
        }, 120000);
      },
      error: (_err: any) => {
        this.IsDisable = false;
        this.toaster.error('Something went wrong');
      },
    });
  }

  //Delete Records We are creating method
  DomainUrl: any;
  SubPlanUrl: any;
  DashboardUrlFlag: boolean = false;
  SubPlanUrlFlag: boolean = false;
  AdminLoginData(data: any, domain: any, flag: any) {
    if (flag == "DomainUrl") {
      this.DashboardUrlFlag = true;
      this.SubPlanUrlFlag = false;
    }
    else {
      this.SubPlanUrlFlag = true;
      this.DashboardUrlFlag = false;
    }
    this.api.AdminLoginData(data, domain).subscribe({
      next: (res: any) => {
        console.log(res);

        if (res.Success) {
          localStorage.setItem("clickhere", JSON.stringify(true));
          localStorage.setItem("token", res["AccessToken"]);
          localStorage.setItem("Name", res["Data"].Name);
          localStorage.setItem("userId", res["Data"].Id);
          localStorage.setItem("companyId", res["Data"].CompanyId);
          localStorage.setItem("CompanyName", res["Data"].CompanyName);
          localStorage.setItem("DoctorTypeId", res["Data"].DoctorTypeId);
          localStorage.setItem("Location", res["Data"].LocationId);
          localStorage.setItem("AspNetRole", res["Data"].AspNetRoleList);
          localStorage.setItem("selectedPlan", res["Data"].selectedPlan);
          localStorage.setItem("AdminLogin", 'true');
          const subscriptionAccesses = res.Data.SubscriptionAccesses ?? [];
          const accessObject = subscriptionAccesses.reduce((acc: { [key: string]: boolean }, item: any) => {
            acc[item.key] = item.IsAccess;
            return acc;
          }, {});
          localStorage.setItem("FeatureAccess", JSON.stringify(accessObject));
          this.api.getDefaultLocation(res["Data"].Id).subscribe({
            next: (response: any) => {
              if (response["Data"] != null && response["Success"] === true) {
                localStorage.setItem(
                  "Location",
                  JSON.stringify({
                    Id: response["Data"].LocationId,
                    Name: response["Data"].LocationName,
                  })
                );

                this.getFormat(
                  res["Data"].CompanyId,
                  res["PermissionData"]
                );
              } else {
                this.getFormat(
                  res["Data"].CompanyId,
                  res["PermissionData"]
                );
              }
            }

          });

        }
        else {
          this.toaster.error("Something went wrong in the login process sorry");
        }

      }, error: (err: any) => {
        this.toaster.error("Something went wrong in the login process sorry");
      }
    })
  }

  async getFormat(id: any, PermissionData: any) {
    try {
      const res: any = await firstValueFrom(this.api.getCompanyByIdpromise(id));

      if (res["Success"] !== true) {
        this.toaster.error("Something went wrong in the login process sorry");
        return;
      }

      const data = res["Data"];
      const storeKeys = (keys: Record<string, any>) => {
        Object.keys(keys).forEach(k => localStorage.setItem(k, keys[k]));
      };

      storeKeys({
        "Referral": data["IsShowReferral"],
        "IsVisibleAdvice": data["IsVisibleAdvice"],
        "IsVisibleDiagnosis": data["IsVisibleDiagnosis"],
        "IsVisibleDocument": data["IsVisibleDocument"],
        "IsVisibleInvestigation": data["IsVisibleInvestigation"],
        "IsVisibleInvoice": data["IsVisibleInvoice"],
        "IsVisiblePayment": data["IsVisiblePayment"],
        "IsVisiblePrescription": data["IsVisiblePrescription"],
        "IsVisibleReference": data["IsVisibleReference"],
        "IsVisibleImmunization": data["IsVisibleImmunization"]
      });

      if (data.CurrencyObj?.CurrencySymbol) {
        localStorage.setItem("Currency", data.CurrencyObj.CurrencySymbol);
      }

      const response: any = await firstValueFrom(this.api.getAll(id));

      if (response["Success"] !== true) return;

      const settings = response['Data'];
      const findValue = (key: string) => settings.find((x: any) => x.Key === key)?.Value;

      const Dformat = findValue("CompanyDateFormat");
      const decimalvalue = findValue("decimal");
      const Referralvalue = findValue("Referral");
      const TimeZonevalue = findValue("TimeZone");

      storeKeys({
        "Dformat": Dformat,
        "decimal": decimalvalue,
        "Referral": Referralvalue,
        "TimeZone": TimeZonevalue
      });

      // Prepare routing variables
      const domain = data.Domain;
      const token = localStorage['token'];
      const Id = localStorage['userId'];
      const CompanyId = data.Id;
      const CompanyName = localStorage['CompanyName'];
      const location = localStorage['Location'];
      const name = data.FirstName;
      const docId = data.DoctorTypeId ?? null;
      const Currency = localStorage['Currency'];
      const IP = localStorage['IA'];
      const AspNetRole = localStorage['AspNetRole'];
      const ReferralLS = localStorage['Referral'];
      const selectedPlan = localStorage['selectedPlan'];
      const AdminLogin = localStorage['AdminLogin'];

      // Decide routing page
      const isDashboard = this.DashboardUrlFlag;
      const routingPage = isDashboard ? "Dashboard" : "Subscription Plan";
      localStorage.setItem("routingPage", routingPage);

      const protocol = domain.includes("ifourtechlab.com") ? "http" : "https";
      const encodedRoutingPage = encodeURIComponent(routingPage);

      // Build URL
      const url = isDashboard
        ? `${protocol}://${domain}/#/Dashboard?${encodeURIComponent(token)}&${encodeURIComponent(Id)}&${encodedRoutingPage}`
        : `${protocol}://${domain}/#/Subscription%20Plan?${encodeURIComponent(token)}&${encodeURIComponent(Id)}&${encodeURIComponent(CompanyId)}&${encodeURIComponent(name)}&${encodeURIComponent(docId)}&${encodeURIComponent(Dformat)}&${encodeURIComponent(decimalvalue)}&${encodeURIComponent(location)}&${encodeURIComponent(TimeZonevalue)}&${encodeURIComponent(Currency)}&${encodeURIComponent(IP)}&${encodeURIComponent(AspNetRole)}&${encodeURIComponent(ReferralLS)}&${encodeURIComponent(CompanyName)}&${encodedRoutingPage}&${encodeURIComponent(selectedPlan)}&${encodeURIComponent(AdminLogin)}`;

      localStorage.setItem("clickhere", JSON.stringify(false));
      window.open(url, "_blank");

    } catch (error) {
      console.error("Error in getFormat:", error);
      this.toaster.error("Something went wrong while fetching company data");
    }
  }
  DeleteClientData() {
    var data = this.deletedData.Id;
    this.LoaderService.show();
    this.api.deleteClientData(data).subscribe({
      next: (_res: any) => {
        this.matDialogRef.close();
        this.toaster.success('Record Deleted Successfully..');
        this.LoaderService.hide();
        this.getDomain();
        this.loadData();
      },
      error: (_err: any) => {
        this.toaster.error('Something went wrong Record not deleted sorry');
      },
    });
  }

  RunMigrationData() {
    if (this.companyId != 0) {
      var Data = localStorage.getItem('companyId');
      this.LoaderService.show();
      this.api.runMigrationData(this.companyId).subscribe({
        next: (_res: any) => {
          this.matDialogRef.close();
          this.toaster.success('Migration Run Successfully');
          this.companyId = 0;
          this.LoaderService.hide();
          this.getDomain();
          this.loadData();
        },
        error: (_err: any) => {
          this.LoaderService.hide();
          this.toaster.error('Something went wrong Record not deleted sorry');
        },
      });
    }
  }

  closeEditDialog() {
    this.emailerror = false;
    this.closeModal.nativeElement.click();
  }

  EditClientData(data: any, templateRef: TemplateRef<any>) {
    this.updateItem = data;
    this.showAdd = false;
    this.showbtn = true;
    this.formValue.patchValue(data);
    this.formValue.controls['IsActive'].setValue(data.IsActive.toString());
    this.onEditChangeStatus = data.IsActive;
    this.isDisableUpdate = !this.onEditChangeStatus;
    this.formValue.controls['IsTestAccount'].setValue(data.IsTestAccount.toString());
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      autoFocus: false,
    });
  }

  getValid() {
    return this.formValue.invalid || this.emailerror;
  }

  onStatusChange(isActive: boolean) {
    this.isDisableUpdate = this.onEditChangeStatus ? false : !isActive;
  }
  updateAdmin() {
    if (this.formValue.invalid || this.emailerror) {
      this.formValue.markAllAsTouched();
      return;
    }
    let obj = {
      Id: this.updateItem.Id,
      Salutation: this.formValue.value.Salutation,
      FirstName: this.formValue.value.FirstName?.trimStart(),
      MobileNumber: this.formValue.value.PhoneNumber,
      PhoneNumber: this.formValue.value.PhoneNumber,
      Gender: this.updateItem.Gender,
      Email: this.formValue.value.Email?.trimStart(),
      CompanyCode: this.updateItem.CompanyName,
      CompanyName: this.updateItem.CompanyName,
      CompanyAddress: this.formValue.value.CompanyAddress?.trimStart(),
      Domain: this.updateItem.Domain,
      IsActive: this.formValue.value.IsActive,
      IsTestAccount: this.formValue.value.IsTestAccount,
      ConnectionString: this.updateItem.ConnectionString,
      ConnectionStringEF: this.updateItem.ConnectionStringEF,
      CurrencyId: this.formValue.value.CurrencyId,
      CompanyDateFormat: this.updateItem.CompanyDateFormat,
      CompanyDecimalFormat: this.updateItem.CompanyDecimalFormat,
      Status: this.updateItem.Status,
      PatientCount: this.updateItem.PatientCount,
      AppointmentCount: this.updateItem.AppointmentCount,
      MigrationStatus: this.updateItem.MigrationStatus,
      MigrationVersionInfo: this.updateItem.MigrationVersionInfo,
      IPAddress: this.updateItem.IPAddress,
      IsTermsAndCondition: this.updateItem.IsTermsAndCondition,
      IsDoctor: this.updateItem.IsDoctor,
      CurrencyObj: {
        Id: 0,
        IsDeleted: true,
        CurrencyCode: '',
        CurrencySymbol: '',
      },
    };


    this.api.updateForAdmin(obj).subscribe({
      next: (res: any) => {
        if (res?.Success && res?.Data) {
          this.toaster.success('User Record Updated Successfully.');
          this.formValue.reset();

          this.getDomain();
          this.loadData();
          this.closeDialog();
        }
        else {
          let message = 'User Record Not Updated.';

          switch (res?.ResponseCode) {
            case 403:
              message = 'Email ID mismatch in domain & main database';
              break;
            case 405:
              message = 'Phone Number already exists.';
              break;
            case 436:
              message = 'Company already exists.';
              break;
            case 409:
              message = 'User not found.';
              break;
            case 551:
              message = 'Domain not found.';
              break;
            case 552:
              message = 'User migration failed.';
              break;
            case 553:
              message = 'User database deleted.';
          }

          this.toaster.error(message);
        }
      },
      error: () => {
        this.toaster.error('Something went wrong. Record not updated.');
      }
    });
  }

  pageChangeEvent(event: number) {
    this.p = event;
    this.allAdminData();
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onlyDigits(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  openDelateDialog(data: any, templateRef: TemplateRef<any>) {
    this.deletedData = data;
    this.domain = data.Domain;
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }
  openAllMigrationDialog(_data: any, templateRef: TemplateRef<any>) {
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }

  openMigrationDialog(data: any, templateRef: TemplateRef<any>) {
    if (data?.Id != 0) {
      this.companyId = data.Id;
    }
    this.domain = data.Domain;
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }
  //Search bar

  filterData(event: any) {
    this.searchString = event;
    this.state.skip = 0;
    this.state.filter = {
      logic: 'or',
      filters: [],
    };
    if (event) {
      this.state.filter.filters = this.columnList.map((field: any) => ({
        ignoreCase: true,
        value: event,
        operator: 'contains',
        field,
      }));
    }
    this.loadData();
    this.getDomain();
  }
  selectedOption(event: any, dataItem: any) {
    this.status = event.value;
    this.selectedCompanyId = dataItem.Id;
    this.LoaderService.show();
    this.api.updateStatus(this.selectedCompanyId, this.status).subscribe(
      (res: any) => {
        this.LoaderService.hide();
        if (res['Success'] === true) {
          if (res['ResponseCode'] === 200) {
            dataItem.Status = event.value;
            this.toaster.success('Status Updated Successfully.');
          }
        } else {
          this.getDomain();
          this.toaster.error('Status update failed.');
        }
      },
      (_err) => {
        this.LoaderService.hide();
        this.toaster.error('Something went wrong Record not Updated sorry');
      }
    );
  }
  checkboxChecked(event: any) {
    let selected: any[] = event.selectedRows;
    let deselected: any[] = event.deselectedRows;
    if (selected.length > 0) {
      selected.map((itm) => {
        this.selectedData.push(itm.dataItem);
      });
    }

    if (deselected.length > 0) {
      deselected.map((itm) => {
        let ind = this.selectedData.findIndex(
          (x: { Id: any }) => x.Id == itm.dataItem.Id
        );
        if (ind != -1) {
          this.selectedData.splice(ind, 1);
        }
      });
    }
  }
  async add(templateRef: TemplateRef<any>) {
    this.isMaximized = false;
    this.state.take = 0;
    await Promise.all([this.getAllNewTemplate(), this.getClientListAsPromise()]);
    this.value = [];
    this.isShow = false;
    this.isInputFieldEmpty = true;
    this.isChecked = false;
    this.templateBody = '';
    this.subject = 'No Reply - [DOMAIN_NAME]';
    if (this.templateData != null && this.templateData.length > 0) {
      this.templateBody = this.templateData[0]?.Body;
      this.hideTemplateId = this.templateData[0]?.Id;
      this.selectedTemplate = this.templateData[0];
    }
    else {
      this.templateBody = ''
      this.hideTemplateId = 0;
      this.selectedTemplate = null;

    }
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
    this.state.take = 10;

  }

  addTemplate(templateRef: TemplateRef<any>) {
    this.isMaximizedEmail = false
    this.value = [];
    this.isShow = false;
    this.isTemplateInputFieldEmpty = true;
    this.isChecked = false;
    this.Name = '';
    this.Body = '';
    this.clientData = this.allAdminData.map((x: any) => x.FirstName);
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'email-dialog-pane',
      autoFocus: false,
    });
  }

  count(templateRef: TemplateRef<any>) {
    this.clientData = this.allAdminData.map((x: any) => x.FirstName);
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }
  submit(form: any) {
    form.controls.Subject.setValue(this.subject);
    form.controls.TemplateBody.setValue(this.templateBody);
    form.controls.Client.setValue(this.value.map((x: any) => x.Id));
    let adminEmailDto = {
      Subject: form.value.Subject,
      CompanyId: this.value.map((x: any) => x.Id),
      TempleteBody: form.value.TemplateBody,
      TempleteName: this.selectedTemplate.Name
    };
    if (form.status == 'VALID' && this.templateBody.trim() != '<p></p>') {
      let data = this.templateBody.replace('<p>', '');
      let data1 = data.replace('</p>', '');
      form.controls.TemplateBody.setValue(data1);
      if (form.controls.TemplateBody.status == 'VALID') {
        this.LoaderService.show();
        this.api.sendAnnouncementEmailforAdmin(adminEmailDto).subscribe(
          (res: any) => {
            if (res['Success'] === true) {
              this.TotalEmails = res.Data.TotalEmails;
              this.TotalSendEmails = res.Data.TotalSendEmails;
              this.TotalUnSendEmails = res.Data.TotalUnSendEmails;
              this.CompantData = res.Data.CompantData;
              this.IsReleaseNote = res.Data.IsReleaseNote;
              if (this.IsReleaseNote)
                this.toaster.success('Release Note Sent Successfully.');
              else
                this.toaster.success('Email process started successfully. Emails are being sent to clients in the background.');
              this.LoaderService.hide();
              this.dialog.closeAll();
              this.count(this.mailCountModal);
              this.getDomain();
            } else {
              this.LoaderService.hide();
              this.toaster.error('Error');
            }
          },
          (_err) => {
            this.LoaderService.hide();
            this.toaster.error('Something went wrong Record not Updated sorry');
          }
        );
      } else {
        this.toaster.error('Template body is required');
      }
    } else {
      this.toaster.error('Please fill all the fields');
    }
  }

  save(form: any) {
    form.controls.Body.setValue(this.Body);
    form.controls.Name.setValue(this.Name);
    let adminEmailTemplateDto = {
      Id: 0,
      Name: form.value.Name,
      Body: form.value.Body,
    };
    if (form.status == 'VALID' && this.Body.trim() != '<p></p>') {
      let data = this.Body.replace('<p>', '');
      let data1 = data.replace('</p>', '');
      form.controls.Body.setValue(data1);
      if (form.controls.Body.status == 'VALID') {
        this.LoaderService.show();
        this.api.adminEmailTemplate(adminEmailTemplateDto).subscribe((res: any) => {
          if (res['Success'] === true) {
            this.LoaderService.hide();
            this.matDialogRef.close();
            this.toaster.success('Template Added Successfully');
            this.getAllNewTemplate(true)
          } else {
            this.LoaderService.hide();
            this.toaster.error('Error');
          }
        },
          (_err) => {
            this.LoaderService.hide();
            this.toaster.error('Something went wrong Record not Updated sorry');
          }
        )
      } else {
        this.toaster.error('Template body is required');
      }
    } else {
      this.toaster.error('Please fill all the fields');
    }

  }

  DeleteTemplate(Item: any) {
    this.IsTemplateClose = Item.Name == "Announcement";
    if (Item.Name == "Announcement") {
      this.toaster.error('The Default email template cannot be deleted');
      return
    }
    this.api.DeleteTemplate(Item).subscribe((res: any) => {
      if (res["Success"] == true) {
        this.toaster.success('Template Delete Successfully');
        this.getAllNewTemplate()
      } else {
        this.toaster.error('Something Went Wrong');
      }
    })
  }

  getTemplateById(Item: any) {
    this.hideTemplateId = Item.Id;
    this.templateName = Item.Name;
    this.isInputFieldEmpty = true
    this.IsTemplateColor = Item.Name == "Announcement";
    this.api.getTemplateById(this.hideTemplateId).subscribe((res: any) => {
      if (res["Success"] == true) {
        this.EmailData = res["Data"].Body
        this.templateBody = this.EmailData;
      }
    });
    this.selectedTemplate = Item;
  }


  getAllNewTemplate(isFromSaveTemplate?: boolean) {
    return new Promise((resolve, reject) => {
      this.IsTemplateClose = this.hideTemplateId === 1;
      this.IsTemplateColor = true;
      this.hideTemplateId = 0;

      this.api.getTemplate().subscribe({
        next: (res: any) => {
          if (res?.Success) {
            this.templateData = res.Data;
            if (isFromSaveTemplate) {
              this.hideTemplateId = this.templateData[this.templateData.length - 1]?.Id ?? 0;
              this.templateBody = this.templateData[this.templateData.length - 1]?.Body ?? '';
              this.selectedTemplate = this.templateData[this.templateData.length - 1];
            }
            else {
              this.hideTemplateId = this.templateData[0]?.Id ?? 0;
              this.templateBody = this.templateData[0]?.Body ?? '';
              this.selectedTemplate = this.templateData[0];

            }

            resolve(true);
          } else {
            reject(new Error('Template fetch failed'));
          }
        },
        error: (err) => {
          reject(new Error('Template fetch failed'));
        }
      });

      //this.getDomain();
    });
  }


  handleKeyDown(event: KeyboardEvent, item: any) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.getTemplateById(item);
    }
  }
  formInIt() {
    this.createMailForm = this.FormBuilder.group({
      Subject: ['', [Validators.required, whitespace]],
      Client: [[], [Validators.required]],
      TemplateBody: ['', [Validators.required, whitespace]],
    });
  }

  emailInit() {
    this.addMailForm = this.FormBuilder.group({
      Name: ['', [Validators.required, whitespace]],
      Body: ['', [Validators.required, whitespace]],
    });
  }
  valueChange(event: any) {
    this.isChecked = this.value.length === this.clientData.length;
  }
  public onClick() {
    this.isChecked = !this.isChecked;
    this.value = this.isChecked ? this.clientData.slice() : [];
  }
  public get toggleAllText() {
    return this.isChecked ? 'Unselect All' : 'Select All';
  }
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };

  public changeFilterOperator(operator: 'contains' | 'startsWith'): void {
    this.filterSettings.operator = operator;
  }
  filterFunction(param: any) {
    this.isShow = false;
    let tets: Element | any;
    let data1: Element | any;
    let data = document.getElementById('test');
    tets = data!.children![0].children[0];
    data1 = document.getElementById(tets?.children[0]!.id);
    let show: Element | any;
    if (!!data1) {
      data1.value;
      show = this.clientData.filter(
        (x: any) =>
          x.FirstName.toLowerCase().startsWith(data1.value.toLowerCase()) ||
          x.FirstName.includes(data1.value) ||
          x.FirstName.toLowerCase().includes(data1.value.toLowerCase())
      );
      if (show.length > 0) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    } else {
      tets = data!.children[0].children.length - 1;
      data1 = document.getElementById(
        data!.children[0].children[tets].children[0].id
      );
      show = this.clientData.filter(
        (x: any) =>
          x.FirstName.toLowerCase().startsWith(data1.value.toLowerCase()) ||
          x.FirstName.includes(data1.value) ||
          x.FirstName.toLowerCase().includes(data1.value.toLowerCase())
      );
      if (show.length > 0) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    }
  }

  //templateBody

  onInputChange(): void {
    // Check if the input field is empty
    if (!!this.templateBody) {
      let data = this.templateBody.replace('<p>', '');
      let data1 = data.replace('</p>', '');
      this.createMailForm.controls['TemplateBody'].setValue(data1);
      if (this.createMailForm.controls['TemplateBody'].status == 'VALID') {
        this.isInputFieldEmpty = true;
      } else {
        this.isInputFieldEmpty = false;
      }
    } else {
      this.isInputFieldEmpty = true;
    }
  }
  InputChange(): void {
    // Check if the input field is empty
    if (!!this.Body) {
      let data = this.Body.replace('<p>', '');
      let data1 = data.replace('</p>', '');
      this.addMailForm.controls['Body'].setValue(data1);
      if (this.addMailForm.controls['Body'].status == 'VALID') {
        this.isTemplateInputFieldEmpty = true;
      } else {
        this.isTemplateInputFieldEmpty = false;
      }
    } else {
      this.isTemplateInputFieldEmpty = true;
    }
  }
  insertTextAtCursor(text: string) {
    this.kendoEditor.exec('insertText', { text: '#CURSOR#' });
    this.kendoEditor.value = this.kendoEditor.value.replace(/#CURSOR#/, text);
    this.templateBody = this.kendoEditor.value;
  }



  getDomain() {
    if (environment.environmentType === "plusdoctor") {
      this.fetchDomainData(this.api.GetPlusDoctorDomain(this.state, JSON.stringify(this.searchString.trim())));
    } else {
      this.fetchDomainData(this.api.GetPlusPhysioDomain(this.state, JSON.stringify(this.searchString.trim())));
    }
  }

  private getDomainAsPromise(): Promise<void> {
    const observable = environment.environmentType === "plusdoctor"
      ? this.api.GetPlusDoctorDomain(this.state, JSON.stringify(this.searchString.trim()))
      : this.api.GetPlusPhysioDomain(this.state, JSON.stringify(this.searchString.trim()));

    return new Promise<void>((resolve) => {
      observable.subscribe({
        next: (res: any) => {
          if (res?.Data) {
            this.allAdminData = res.Data.map((e: any) => this.transformCompany(e));
          } else {
            this.allAdminData = [];
          }
          resolve();
        },
        error: () => resolve()
      });
    });
  }

  private getClientListAsPromise(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.api.GetClientList(environment.environmentType).subscribe({
        next: (res: any) => {
          if (res?.Data) {
            this.clientData = Object.entries(res.Data)
              .filter(([, firstName]) => !!firstName)
              .map(([id, firstName]) => ({ Id: +id, FirstName: firstName as string }));
          } else {
            this.clientData = [];
          }
          resolve();
        },
        error: () => resolve()
      });
    });
  }

  private fetchDomainData(observable: Observable<any>): void {
    this.LoaderService.show();
    if (this.formValue != undefined) {
      this.formValue.controls['CompanyName'].disable();
    }
    if (this.state.filter) {
      this.state.filter.filters = [];
    }

    observable.subscribe({
      next: (res: any) => this.handleDomainResponse(res),
      error: (err: any) => {
        this.LoaderService.hide();
        console.error(`Error fetching domain data:`, err);
        this.toaster.error('Something went wrong while fetching record');
      }
    });
  }

  private handleDomainResponse(res: any): void {
    if (res?.Data) {
      this.allAdminData = res.Data.map((e: any) => this.transformCompany(e));

      forkJoin(
        this.allAdminData.map((company: any) =>
          forkJoin({
            usage: this.api.getUsageOverview(company.Id),
            addOns: this.api.getAddOnDetails(company.Id)
          })
        )
      ).subscribe((results: any) => this.applyUsageResults(results));

      this.total = res.Total;

      if (this.state.filter) {
        this.state.filter.filters = [];
      }
      this.setColumnList();
      this.loadData();
    } else {
      this.allAdminData = [];
      this.total = 0;
    }
    this.LoaderService.hide();
  }

  private transformCompany(e: any): any {
    e.CreatedDate = e.CreatedDate.split('T')[0];
    e.CreatedDate = this.datePipe.transform(new Date(e.CreatedDate), 'dd-MM-yyyy');

    const data = this.currencyList.filter((x: any) => x.Id == e.CurrencyId);
    if (data.length > 0) {
      e.Country = data[0].CountryName;
    }

    e.IsWhatsAppIntegration = e.IsWhatsAppIntegration ? 'Subscribed' : 'Not Subscribed';
    return e;
  }

  private applyUsageResults(results: any[]): void {
    results.forEach((result: any, index: any) => {
      const company = this.allAdminData[index];
      const latestUsage = result.usage?.Data?.[0] ?? null;

      if (company.AddOnDetails?.length > 0) {
        company.AddOnDetails = company.AddOnDetails.map((detail: any) =>
          this.mapAddonUsage(detail, latestUsage)
        );
      }
    });
    this.loadData();
  }

  private mapAddonUsage(detail: any, latestUsage: any): any {
    let used = 0;
    if (latestUsage) {
      if (detail.TypeName === 'User') used = latestUsage.TotalAddonUsers;
      else if (detail.TypeName === 'Location') used = latestUsage.TotalLocations;
      else if (detail.TypeName === 'Patients') used = latestUsage.TotalPatients;
      else if (detail.TypeName === 'Storage') used = latestUsage.TotalStorage;
    }
    return { ...detail, addonUsage: used };
  }

  private setColumnList(): void {
    this.columnList = [
      'FirstName',
      'CompanyName',
      'Email',
      'VerificationCode',
      'PhoneNumber',
      'CompanyAddress',
      'Domain',
      'Status',
      'PatientCount',
      'Country',
      'AppointmentCount',
      'CreatedDate',
      'IPAddress',
      'IsWhatsAppIntegration'
    ];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setGridHeight();
  }

  setGridHeight(): void {
    const headerHeight = 70; // Adjust according to your header and other elements
    const footerHeight = 61;
    const otherElementsHeight = 125;
    this.gridHeight = window.innerHeight - headerHeight - footerHeight - otherElementsHeight;
  }

  clearList() {
    this.searchString = '';
    this.getDomain();
  }

  onColumnVisibilityChange(columnEvent: GridComponent) {
    let currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    const data = columnEvent.columns["_results"]
      .filter((x: any) => x?.hidden != true)
      .map((x: any) => x.field);
    const jsonData = JSON.stringify(data);
    const reqBody = {
      Id: 0,
      PersistString: jsonData,
      TableName: "Client Details",
      DomainName: localStorage.getItem("UserName"),
      CreatedOn: currentDate,
      CreatedBy: localStorage.getItem("UserName"),
    };
    this.api.AdminGridSettingAddData(reqBody).subscribe((res: any) => {
      if (res["Success"]) {
        this.toaster.success("Changes Saved");
      } else {
        this.toaster.error("Changes Not Saved");
      }
    });
  }

  ngAfterViewInit(): void {
    this.api.GetDomainName(localStorage.getItem("UserName"), this.TableName).subscribe((res: any) => {
      const data = res["Data"];
      if (data && data.PersistString) {
        this.displayColumns = JSON.parse(data.PersistString);
        const grid = this.gridKendo.columns["_results"];
        grid.forEach((column: any) => {
          if (!this.displayColumns.includes(column.field)) {
            column.hidden = true;
          }
        });
      }
    });
  }

  openAddOnDialog(data: any, addOnTemplate: TemplateRef<any>) {
    if (data.IsAutoRenew) {
      this.toaster.error('Auto-Renewal is active. Ask the user to purchase the Add-on directly.');
      return;
    }

    let expiryDate: Date = new Date(data.PlanExpiryDate);
    let currentDate: Date = new Date();

    const compYear = expiryDate.getFullYear();
    const compMonth = expiryDate.getMonth();
    const compDay = expiryDate.getDate();

    const currYear = currentDate.getFullYear();
    const currMonth = currentDate.getMonth();
    const currDay = currentDate.getDate();

    if (compYear < currYear ||
      (compYear === currYear && compMonth < currMonth) ||
      (compYear === currYear && compMonth === currMonth && compDay < currDay)) {
      this.toaster.error('The domain plan has expired. Add-ons cannot be added at this time.');
      return;
    }

    this.companyId = data.Id;

    this.api.getActiveAddOnDetails(this.companyId).subscribe((res: any) => {
      if (res?.Success) {
        const activeAddOns = res.Data ?? [];
        const addOnCountMap = activeAddOns.reduce((acc: any, item: any) => {
          acc[item.AddOnTypeId] = (acc[item.AddOnTypeId] ?? 0) + (item.AddOnCount ?? 0);
          return acc;
        }, {});

        this.addOns = this.originalAddOns.map(addOn => ({
          ...addOn,
          quantity: 0,
          previousQuantity: addOnCountMap[addOn.id] ?? 0
        }));
      }
      else {
        this.addOns = this.originalAddOns.map(addOn => ({
          ...addOn,
          quantity: 0,
          previousQuantity: 0
        }));
      }
    });

    this.matDialogRef = this.dialog.open(addOnTemplate, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }

  increment(item: any) {
    if (item.name === 'Patients') {
      item.quantity = (item.quantity || 0) + 1000;
    } else if (item.name === 'Storage') {
      item.quantity = (item.quantity || 0) + 100;
    } else {
      item.quantity = (item.quantity || 0) + 1;
    }
  }

  decrement(item: any) {
    if (item.name === 'Patients' && item.quantity > 0) {
      item.quantity -= 1000;
    } else if (item.name === 'Storage' && item.quantity > 0) {
      item.quantity -= 100;
    } else if (item.name !== 'Patients' && item.name !== 'Storage' && item.quantity > 0) {
      item.quantity -= 1;
    }
  }

  getAddOnTotal(): number {
    return this.addOns.reduce((sum, item) => sum + (item.id == 3 ? (item.quantity / 1000 * item.price) : (item.id == 4 ? item.quantity / 100 * item.price : item.quantity * item.price)), 0);
  }

  submitAddOn() {
    const loginData = localStorage.getItem("loginData");
    if (!loginData) return;

    this.LoaderService.show();
    const userId = JSON.parse(loginData).Id;
    var addOns = this.addOns.filter(i => i.quantity > 0)

    if (addOns.length === 0) {
      this.LoaderService.hide();
      this.toaster.error('Please select at least one add-on.');
      return;
    }

    var payload: any = [];
    addOns.forEach(element => {
      payload.push({
        CompanyId: this.companyId,
        AddOnTypeId: element.id,
        AddOnCount: element.quantity,
        AddOnAmount: (element.id == 3 ? (element.quantity / 1000 * element.price) : (element.id == 4 ? element.quantity / 100 * element.price : element.quantity * element.price)),
        AddOnBaseAmount: element.price,
        CreatedBy: userId
      })
    })

    this.api.createAddOnDetails(payload).subscribe((res: any) => {
      if (res["Success"]) {
        this.toaster.success('Add-on configuration saved successfully.');
        this.matDialogRef.close();
        this.getDomain();
        this.loadData();
        this.LoaderService.hide();
      } else {
        this.LoaderService.hide();
        this.toaster.error('Something went wrong');
      }
    });
  }

  setItemPrice(event: any, item: any) {
    var itemPrice = event?.target?.value ? parseFloat(event.target.value) : 0
    this.addOns = this.addOns.map(addOn =>
      addOn.id === item.id ? { ...addOn, price: itemPrice } : addOn)
  }

  onlyPositiveNumbers(event: any) {
    let input: string;

    // Handle keyboard typing
    if (event.type === 'keypress') {
      input = event.key;
      if (!/^\d$/.test(input)) {
        event.preventDefault();
      }
    }

    // Handle pasting
    if (event.type === 'paste') {
      input = event.clipboardData?.getData('text') ?? '';
      if (!/^\d+$/.test(input)) {
        event.preventDefault();
      }
    }
  }

  openChangePlanDialog(data: any, templateRef: TemplateRef<any>) {
    if (data.IsAutoRenew) {
      this.toaster.error('Please disable auto-renewal before changing the plan.');
      return;
    }

    this.isPlanYearly = false;
    this.selectedRecord = data;
    this.isSendInvoice = true;
    this.selectedPlanId = data.PlanId;
    this.api.getSubscriptionDetails(this.selectedRecord?.Id).subscribe({
      next: (res: any) => {
        if (res["Success"] && res["ResponseCode"] === 200 && res["Data"]) {
          const subData = res["Data"][0];
          if (subData?.TransactionCurrencyId) {
            this.selectedCurrencyId = subData?.TransactionCurrencyId;
            const currencyCode = this.getCurrencyCodeById(this.selectedCurrencyId);
            this.updatePlanPrices(currencyCode);
          }
          if (!this.selectedPlanId && subData?.PlanId) {
            this.selectedPlanId = subData.PlanId;
          }
        }
      }
    });

    this.expiryDate = new Date();
    if (this.isPlanYearly) {
      // Add 365 days
      this.expiryDate.setDate(this.expiryDate.getDate() + 365);
    } else {
      // Add 30 days
      this.expiryDate.setDate(this.expiryDate.getDate() + 30);
    }

    const currencyCode = this.getCurrencyCodeById(this.selectedCurrencyId);
    this.plans = [
      {
        id: SubscriptionPlanType.BasicPlan,
        name: 'Basic Plan',
        monthlyPrice: this.planPrices[SubscriptionPlanType.BasicPlan][currencyCode].monthly,
        annualPrice: this.planPrices[SubscriptionPlanType.BasicPlan][currencyCode].annual,
        isShowAddOn: false,
        expriyDate: this.expiryDate,
      },
      {
        id: SubscriptionPlanType.StandardPlan,
        name: 'Standard Plan',
        monthlyPrice: this.planPrices[SubscriptionPlanType.StandardPlan][currencyCode].monthly,
        annualPrice: this.planPrices[SubscriptionPlanType.StandardPlan][currencyCode].annual,
        isShowAddOn: false,
        expriyDate: this.expiryDate,
      },
      {
        id: SubscriptionPlanType.PremiumPlan,
        name: 'Premium Plan',
        monthlyPrice: this.planPrices[SubscriptionPlanType.PremiumPlan][currencyCode].monthly,
        annualPrice: this.planPrices[SubscriptionPlanType.PremiumPlan][currencyCode].annual,
        isShowAddOn: false,
        expriyDate: this.expiryDate,
      },
      {
        id: SubscriptionPlanType.EnterprisePlan,
        name: 'Enterprise Plan',
        monthlyPrice: this.planPrices[SubscriptionPlanType.EnterprisePlan][currencyCode].monthly,
        annualPrice: this.planPrices[SubscriptionPlanType.EnterprisePlan][currencyCode].annual,
        isShowAddOn: false,
        expriyDate: this.expiryDate,
      }
    ];

    if (data.AddOnDetails && data.AddOnDetails.length > 0) {
      let addOnAmount = data.AddOnDetails.reduce(
        (n: number, { AddOnAmount }: { AddOnAmount: number }) => n + AddOnAmount,
        0
      );

      this.plans = this.plans.map(plan => {
        if ((plan.id === SubscriptionPlanType.StandardPlan || plan.id === SubscriptionPlanType.PremiumPlan) && plan.id >= this.selectedPlanId) {
          const monthly = parseInt(plan.monthlyPrice.replace(/[^\d]/g, '')) || 0;
          const annual = parseInt(plan.annualPrice.replace(/[^\d]/g, '')) || 0;

          return {
            ...plan,
            monthlyPrice: `${monthly + addOnAmount}`,
            annualPrice: `${annual + addOnAmount}`,
            isShowAddOn: true
          };
        }
        return plan;
      });
    }

    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
      width: '800px',
    });
  }

  changePlan(plan: any) {
    this.newPlan = plan;
    this.newPlan.expriyDate = this.expiryDate;

    const isPaidPlan = this.newPlan.id > SubscriptionPlanType.BasicPlan;
    const price = this.isPlanYearly ? this.newPlan.annualPrice : this.newPlan.monthlyPrice;
    const planPrice = isPaidPlan ? price : 0;

    if (planPrice === '' || planPrice === null || planPrice === undefined || planPrice === '-' || Number.parseFloat(planPrice) < 0) {
      this.toaster.error('Please enter a valid price.');
      return;
    }

    this.confirmationDialog = this.dialog.open(this.changePLanConfirmationDialog, {
      disableClose: true,
      panelClass: "popup_custom_width_small",
      autoFocus: false,
    });
  }

  updatePlan() {
    let price = this.newPlan.id > SubscriptionPlanType.BasicPlan ? (this.isPlanYearly ? this.newPlan.annualPrice : this.newPlan.monthlyPrice) : 0;
    price = parseFloat(price)

    let stripePaymentModel = {
      CompanyId: this.selectedRecord?.Id,
      Amount: price,
      TotalAmount: price,
      UserId: 0,
      TransactionTypeId: 2,
      //set 0 means dont't use SubscriptionPlanId from frontend.
      SubscriptionPlanId: 0,
      PlanId: this.newPlan?.id,
      IsMonth: !this.isPlanYearly,
      IPAddress: this.ipAddress,
      ExpiryDate: this.newPlan?.expriyDate ? this.formatDateLocal(this.newPlan?.expriyDate) : null,
      TransactionCurrencyId: this.selectedCurrencyId,
      IsSendInvoice: this.isSendInvoice,
      IsAdminRedirect: true
    }

    this.LoaderService.show();
    this.api.AddTransactionDetails(stripePaymentModel).subscribe({
      next: (res: any) => {
        if (res["Success"]) {
          this.toaster.success('Plan changed successfully.');
          this.matDialogRef.close();
          this.confirmationDialog.close();
          this.LoaderService.hide();
          this.sendPlanChangeEmail();
          this.forceLogoutAllUsers();

          //If plan is upgraded from basic/standard to premium/enterprise then create domain
          if (stripePaymentModel.SubscriptionPlanId > 6 && this.selectedRecord?.SubscriptionPlanId <= 6) {
            this.CreateDomain(stripePaymentModel.CompanyId);
          } else {
            this.getDomain();
            this.loadData();
          }
        } else {
          this.LoaderService.hide();
          this.confirmationDialog.close();
          this.toaster.error('Something went wrong while changing the plan.');
        }
      }
    });
  }

  formatDateLocal(dateString: string): string {
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  closeConfirmationDialog() {
    this.confirmationDialog.close();
  }

  sendPlanChangeEmail() {
    let selectedRec = this.selectedRecord;
    let newPlan = this.newPlan;
    let userName = selectedRec.FirstName + ' ' + (selectedRec.LastName || '');
    let action = newPlan.id > selectedRec.PlanId ? 'Upgraded' : (newPlan.id < selectedRec.PlanId ? 'Downgraded' : 'Renewed');

    let adminEmailDto = {
      Subject: 'Subscription Update – Plan Changed Successfully',
      CompanyId: [selectedRec?.Id],
      TempleteBody: `<p>Hi&nbsp;${userName},</p>
    <p>Your plan has been successfully <b>${action}</b>, effective today.</p>
    <p><b>Plan Name:</b> ${newPlan.name}<br><b>Status:</b> ${action}</p>
    <p>Thank you for choosing PlusPhysio. You can manage your subscription anytime from your subscription settings.<br>
    If you have any questions or suggestions, please feel free to contact us at [SUPPORT_NAME] or call us at <b>[CONTACT_NUMBER]</b>.</p>
    </p>
    <p><b>Best regards,</b>
    <br>
    <b>The PlusPhysio Team</b></p>`,
    };

    this.api.sendAnnouncementEmailforAdmin(adminEmailDto).subscribe({
      error: () => { }
    });
  }

  forceLogoutAllUsers() {
    this.api.logoutAllUsers(this.selectedRecord?.Id).subscribe({
      error: () => { }
    });
  }

  openMastermigrationDialog(_data: any, templateRef: TemplateRef<any>) {
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }
  openResetPasswordDialog(data: any) {
    this.selectedUser = data;

    this.matDialogRef = this.dialog.open(this.changeResetPasswordDialog, {
      disableClose: true,
      autoFocus: false,
    });

    this.matDialogRef.afterOpened().subscribe({
      next: () => {
        this.resetInit();
      }
    });
  }
  onIconKeyDown(event: KeyboardEvent) {
    const key = event.key;
    // activate on Enter or Space (Space: prevent page scrolling)
    if (key === 'Enter' || key === ' ') {
      event.preventDefault();           // important for Space
      this.toggleNewPasswordVisibility();
    }
  }
  onIconKeyDownConfirm(event: KeyboardEvent) {
    const key = event.key;
    // activate on Enter or Space (Space: prevent page scrolling)
    if (key === 'Enter' || key === ' ') {
      event.preventDefault();           // important for Space
      this.toggleConfirmPasswordVisibility();
    }
  }
  toggleNewPasswordVisibility(): void {
    this.hideNewPassword = !this.hideNewPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }
  control(controlName: string): AbstractControl | null {
    return this.form.get(controlName);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.control(controlName);
    if (!control) return false;
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  addMasterMigration() {
    this.IsDisable = true;
    this.LoaderService.show();
    this.api.addMasterMigration().subscribe({
      next: (_res) => {
        this.toaster.success('Migration Run Successfully..');
        this.matDialogRef.close();
        this.LoaderService.hide();
        setTimeout(() => {
          this.IsDisable = false;
        }, 2000);
      },
      error: (_err: any) => {
        this.IsDisable = false;
        this.toaster.error('Something went wrong');
      },
    });
  }

  updatePlanPrice(index: number, newValue: any) {
    if (this.isPlanYearly) {
      this.plans[index].annualPrice = newValue?.target?.value;
    } else {
      this.plans[index].monthlyPrice = newValue?.target?.value;
    }
  }
  getStatusColor(status: string): string {
    switch (status) {
      case 'Registered':
        return '#D95922';
      case 'OTPVerified':
        return '#044B4F';
      case 'LoggedIn':
        return 'green';
      default:
        return 'black';
    }
  }

  // Version of the FluentMigrator migration that marks a company's database as ready for the
  // new platform - matches NewPlatformMigrationVersion in PlusDoctor.Services.UserService.
  private readonly newPlatformMigrationVersion = 20260813160000;

  isNewPlatformMigrated(dataItem: any): boolean {
    const appliedVersion = Number(dataItem?.MigrationVersionInfo);
    return !isNaN(appliedVersion) && appliedVersion >= this.newPlatformMigrationVersion;
  }

  whatsappFormInit() {
    this.whatsappForm = this.FormBuilder.group({
      Provider: ['Ifour'],
      InstanceKey: ['', [Validators.required, whitespace]],
      IsGloble: [true], // true = Global, false = Location-wise
      LocationId: [null],
      ExpiryDate: [null, Validators.required],
      Amount: [0, [Validators.required, Validators.min(0)]],
    });

    this.whatsappForm.get('Provider')?.valueChanges.subscribe({
      next: (value) => {
        const instanceKeyControl = this.whatsappForm.get('InstanceKey');
        if (value === 'SmsIdea') {
          instanceKeyControl?.setValidators([Validators.required, whitespace as any]);
        } else {
          instanceKeyControl?.clearValidators();
        }
        instanceKeyControl?.updateValueAndValidity();
      }
    });

    // Handle LocationType changes (true = Global, false = Location-wise)
    this.whatsappForm.get('IsGloble')?.valueChanges.subscribe({
      next: (value) => {
        const locationIdControl = this.whatsappForm.get('LocationId');
        if (value === false) { // Location-wise
          locationIdControl?.setValidators([Validators.required]);
        } else { // Global (true)
          locationIdControl?.clearValidators();
          // Set to first location when Global is selected
          if (this.locationList.length > 0) {
            locationIdControl?.setValue(this.locationList[0].Id);
          }
        }
        locationIdControl?.updateValueAndValidity();
      }
    });
  }

  async openWhatsappEnableDialog(data: any, templateRef: TemplateRef<any>) {
    this.isWhatsappSubmitted = false;
    this.resetWhatsappForm();
    this.selectedRecord = data;
    this.whatsappForm.patchValue({ Provider: 'Ifour' });

    this.LoaderService.show();
    try {
      await this.getLocations(data.Id);

      this.matDialogRef = this.dialog.open(templateRef, {
        disableClose: true,
        autoFocus: false,
      });
    } finally {
      this.LoaderService.hide();
    }
  }

  openAIAssistantDialog(data: any, templateRef: TemplateRef<any>) {
    this.selectedRecord = data;

    this.api.getGeneralSetting(this.selectedRecord.Id, this.aiKeyName).subscribe((res: any) => {
      this.isAIEnabled = res?.Data?.Value?.toLowerCase() === 'true';
    })

    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      autoFocus: false,
    });
  }

  updateAIAssistantStatus() {
    this.LoaderService.show();

    const settingDto = {
      Key: this.aiKeyName,
      Value: this.isAIEnabled.toString().toLowerCase()
    };

    this.api.updateGeneralSettingByDomain(this.selectedRecord.Id, settingDto).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.toaster.success(`AI Assistant ${this.isAIEnabled ? 'Enabled' : 'Disabled'} Successfully`);
          this.matDialogRef.close();
        } else {
          this.toaster.error('Failed to update AI Assistant status');
        }
        this.LoaderService.hide();
        this.cd.detectChanges();
      },
      error: (err) => {
        this.toaster.error(err?.message);
        this.LoaderService.hide();
        this.cd.detectChanges();
      }
    });
  }

  getLocations(companyId: any): Promise<void> {
    return firstValueFrom(this.api.getLocations(companyId)).then((res) => {
      if (res.Success) {
        this.locationList = res['Data'];
        if (this.locationList.length > 0) {
          this.whatsappForm.get('LocationId')?.setValue(this.locationList[0].Id);
        }
      } else {
        this.locationList = [];
      }
      this.cd.detectChanges();
    });
  }

  resetWhatsappForm() {
    this.locationList = [];
    this.whatsappForm.reset({
      Provider: 'SendClean',
      InstanceKey: null,
      IsGloble: true, // true = Global
      LocationId: null,
      ExpiryDate: null
    });
  }

  addWhatsappInstance() {
    this.isWhatsappSubmitted = true;
    if (this.whatsappForm.invalid) {
      Object.keys(this.whatsappForm.controls).forEach(key => {
        const control = this.whatsappForm.get(key);
        control?.markAsTouched();
        control?.updateValueAndValidity();
      });
      return;
    }
    let obj = {
      CompanyId: this.selectedRecord.Id,
      LocationId: this.whatsappForm.value.LocationId,
      IPAddress: this.ipAddress,
      InstanceKey: this.whatsappForm.value.InstanceKey,
      Provider: this.whatsappForm.value.Provider,
      ExpiryDate: this.formatDateLocal(this.whatsappForm.value.ExpiryDate),
      Amount: this.whatsappForm.value.Amount,
      IsGloble: this.whatsappForm.value.IsGloble
    };

    this.LoaderService.show();
    this.api.enableWhatsappInstance(obj).subscribe({
      next: (res: any) => {
        if (res["Success"] === true) {
          this.toaster.success('Whatsapp Instance Created Successfully..');
          this.matDialogRef.close();
          this.whatsappForm.reset();
        } else if (res["ResponseCode"] == 555) {
          this.toaster.error("Whatsapp Instance is not valid.");
        } else if (res["ResponseCode"] == 435) {
          this.toaster.error("Company Not Found.");
        }
        this.LoaderService.hide();
      }, error: (err: any) => {
        this.toaster.error('Something went wrong Record not updated sorry');
        this.LoaderService.hide();
      }
    });
  }

  onPlanToggle(event: any) {
    if (event.checked) {
      this.isPlanYearly = true;
      this.expiryDate = new Date(this.today);
      this.expiryDate.setDate(this.expiryDate.getDate() + 365);
    } else {
      this.isPlanYearly = false;
      this.expiryDate = new Date(this.today);
      this.expiryDate.setDate(this.expiryDate.getDate() + 30);
    }

  }

  onExpiryDateChange(index: number, event: any) {
    this.plans[index].expriyDate = event.value;
    this.expiryDate = event.value;
  }
  onTemplateChange(item: any) {
    item?.Id ? this.getTemplateById(item) : this.removeTemplate();
  }

  removeTemplate() {
    this.selectedTemplate = null;
    this.hideTemplateId = null;
    this.templateName = '';
    this.isInputFieldEmpty = false;
    this.IsTemplateColor = false;
    this.EmailData = '';
    this.templateBody = '';
  }

  resetInit() {
    this.form = this.FormBuilder.group(
      {
        NewPassword: ["", [Validators.required,]],
        ConfirmPassword: ["", [Validators.required]],
      },
      {
        validators: Validation.match('NewPassword', 'ConfirmPassword'), // call the method
      }
    );
  }

  async submitResetForm() {

    if (this.form.invalid) {
      this.form.markAllAsTouched();  // highlight errors
      return;                        // stop execution
    }
    const passwordObj = {
      Domain: this.selectedUser.Domain,
      Email: this.selectedUser.Email,
      NewPassword: this.form.value.NewPassword,
      ConfirmPassword: this.form.value.ConfirmPassword,
    };

    this.loading = true;
    this.LoaderService.show();

    passwordObj.NewPassword = this.encryptionService.encrypt(passwordObj?.NewPassword);
    passwordObj.ConfirmPassword = this.encryptionService.encrypt(passwordObj?.ConfirmPassword);

    this.api.resetPassword(passwordObj).subscribe({
      next: (response: any) => {
        if (response.Success) {
          this.close();
          if (response.ResponseCode === 200) {
            this.toaster.success('Password Changed Successfully.');
          }
        } else {
          switch (response.ResponseCode) {
            case 414:
              this.toaster.error('Password reset failed.');
              break;
            case 411:
              this.toaster.error('User is Inactive.');
              break;
            case 409:
              this.toaster.error('User not found.');
              break;
            default:
              this.toaster.error('Something went wrong, record not updated.');
              break;
          }
        }

        this.loading = false;
        this.LoaderService.hide();
      },
      error: (err) => {
        this.toaster.error('Something went wrong. Please try again later.');
        this.loading = false;
        this.LoaderService.hide();
      }
    });
  }

  close() {
    this.dialog.closeAll();
  }



  planLimitInit() {
    this.planLimitForm = this.FormBuilder.group({
      ServiceItem: ['', [Validators.required, whitespace]],
      PatientCustomField: ['', [Validators.required, whitespace]],
      Reference: ['', [Validators.required, whitespace]],
    });
  }

  async openPlanLimitDialog(dataItem: any) {
    this.resetPlanLimitForm();
    this.selectedUser = dataItem;
    await this.getPlanlimits(dataItem.Id);
    this.dialog.open(this.planLimitDialog, {
      disableClose: true,
      autoFocus: false,
    });
  }

  resetPlanLimitForm() {
    this.planLimitForm.reset({
      ServiceItem: '',
      PatientCustomField: '',
      Reference: ''
    });
  }

  async getPlanlimits(Id: number) {
    this.loading = true;
    this.LoaderService.show();
    const response: any = await firstValueFrom(this.api.getPlanLimit(Id));
    if (response.Success) {
      this.planLimitForm.patchValue({
        ServiceItem: response?.Data?.ServiceItem,
        PatientCustomField: response?.Data?.PatientCustomField,
        Reference: response?.Data?.Reference
      });
    } else {
      this.toaster.error('Something went wrong, record not updated.');
    }
    this.loading = false;
    this.LoaderService.hide();
  }

  updatePlanLimit() {
    if (!this.planLimitForm.valid) {
      return;
    }
    this.loading = true;
    this.LoaderService.show();
    let payload = {
      CompanyId: this.selectedUser.Id,
      ServiceItem: this.planLimitForm.value.ServiceItem,
      PatientCustomField: this.planLimitForm.value.PatientCustomField,
      Reference: this.planLimitForm.value.Reference,
    };
    this.api.updatePlanLimit(payload).subscribe({
      next: (response: any) => {
        if (response.Success) {
          this.close();
          if (response.ResponseCode === 200) {
            this.toaster.success('Plan Limit updated Successfully.');
          }
        } else {
          this.toaster.error('Something went wrong, record not updated.');
        }
        this.loading = false;
        this.LoaderService.hide();
      },
      error: (err) => {
        this.toaster.error('Something went wrong. Please try again later.');
        this.loading = false;
        this.LoaderService.hide();
      }
    });
  }

  creditLimitInit() {
    this.creditLimitForm = this.FormBuilder.group({
      CreditLimit: ['', [Validators.required, whitespace]],
    });
  }

  async openCreditLimitDialog(dataItem: any) {
    this.resetCreditLimitForm();
    this.selectedUser = dataItem;
    await this.getCreditLimits(dataItem.Id);
    this.dialog.open(this.creditLimitDialog, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
      width: '400px',
    });
  }

  resetCreditLimitForm() {
    this.creditLimitForm.reset({
      CreditLimit: '',
    });
  }

  async getCreditLimits(Id: number) {
    this.loading = true;
    this.LoaderService.show();
    const response: any = await firstValueFrom(this.api.getCreditLimit(Id));
    if (response.Success) {
      this.remainingCreditLimit = response?.Data?.Balance;
    } else {
      this.toaster.error('Something went wrong, record not updated.');
    }
    this.loading = false;
    this.LoaderService.hide();
  }

  updateCreditLimit() {
    if (!this.creditLimitForm.valid) {
      return;
    }
    this.loading = true;
    this.LoaderService.show();
    let payload = {
      CompanyId: this.selectedUser.Id,
      Balance: this.creditLimitForm.value.CreditLimit,
    };
    this.api.updateCreditLimit(payload).subscribe({
      next: (response: any) => {
        if (response.Success) {
          this.close();
          if (response.ResponseCode === 200) {
            this.toaster.success('Credit Limit updated Successfully.');
          }
        } else {
          this.toaster.error('Something went wrong, record not updated.');
        }
        this.loading = false;
        this.LoaderService.hide();
      },
      error: (err) => {
        this.toaster.error('Something went wrong. Please try again later.');
        this.loading = false;
        this.LoaderService.hide();
      }
    });
  }
  toggleMaximize(): void {
    const overlayPane = document.querySelector('.cdk-overlay-pane:has(mat-dialog-container)');
    if (!(overlayPane instanceof HTMLElement)) return;
    const dialogElement = document.querySelector('mat-dialog-container');
    if (!(dialogElement instanceof HTMLElement)) return;
    const contentElement = dialogElement?.querySelector('.mat-dialog-content');
    if (!(contentElement instanceof HTMLElement)) return;
    this.mapService.maximizeMinimize();
    if (!overlayPane || !dialogElement) return;
    this.isMaximized = !this.isMaximized;
    if (this.isMaximized) {
      // Save original styles only once
      if (!this.originalOverlayStyle.width) {
        this.originalOverlayStyle = {
          position: overlayPane.style.position,
          top: overlayPane.style.top,
          left: overlayPane.style.left,
          margin: overlayPane.style.margin,
          width: overlayPane.style.width,
          height: overlayPane.style.height,
          maxWidth: overlayPane.style.maxWidth,
          maxHeight: overlayPane.style.maxHeight
        };

        this.originalDialogStyle = {
          width: dialogElement.style.width,
          height: dialogElement.style.height,
          maxHeight: dialogElement.style.maxHeight
        };
      }

      // Apply maximize styles
      overlayPane.style.position = 'fixed';
      overlayPane.style.top = '0';
      overlayPane.style.left = '0';
      overlayPane.style.margin = '0';
      overlayPane.style.setProperty('width', '100vw', 'important');
      overlayPane.style.setProperty('height', '100vh', 'important');
      overlayPane.style.setProperty('max-width', '100vw', 'important');
      overlayPane.style.setProperty('max-height', '100vh', 'important');

      dialogElement.style.setProperty('width', '100vw', 'important');
      dialogElement.style.setProperty('max-width', '100vw', 'important');
      contentElement.style.maxHeight = '72vh';
    } else {
      // Restore original styles
      overlayPane.style.position = this.originalOverlayStyle.position ?? '';
      overlayPane.style.top = this.originalOverlayStyle.top ?? '';
      overlayPane.style.left = this.originalOverlayStyle.left ?? '';
      overlayPane.style.margin = this.originalOverlayStyle.margin ?? '';
      overlayPane.style.width = this.originalOverlayStyle.width ?? '';
      overlayPane.style.height = this.originalOverlayStyle.height ?? '';
      overlayPane.style.maxWidth = this.originalOverlayStyle.maxWidth ?? '';
      overlayPane.style.maxHeight = this.originalOverlayStyle.maxHeight ?? '';

      dialogElement.style.width = this.originalDialogStyle.width ?? '';
      dialogElement.style.height = this.originalDialogStyle.height ?? '';
      contentElement.style.maxHeight = this.originalDialogStyle.maxHeight ?? '';
    }
  }

  toggleMaximize1(): void {
    const overlayPane = document.querySelector('.cdk-overlay-pane.email-dialog-pane') as HTMLElement;
    if (!overlayPane) return;
    const dialogElement = overlayPane.querySelector('mat-dialog-container') as HTMLElement;
    const contentElement = dialogElement?.querySelector('.mat-dialog-content') as HTMLElement;
    if (!dialogElement || !contentElement) return;

    this.isMaximizedEmail = !this.isMaximizedEmail;
    if (this.isMaximizedEmail) {
      this.originalOverlayStyleEmail = {
        width: overlayPane.style.width,
        height: overlayPane.style.height,
        maxWidth: overlayPane.style.maxWidth,
        maxHeight: overlayPane.style.maxHeight
      };

      overlayPane.style.position = 'fixed';
      overlayPane.style.top = '0';
      overlayPane.style.left = '0';
      overlayPane.style.width = '100vw';
      overlayPane.style.height = '100vh';
      overlayPane.style.maxWidth = '100vw';
      overlayPane.style.maxHeight = '100vh';

      dialogElement.style.width = '100vw';
      dialogElement.style.maxWidth = '100vw';
      contentElement.style.maxHeight = '72vh';
    } else {
      overlayPane.style.position = this.originalOverlayStyle.position ?? '';
      overlayPane.style.top = this.originalOverlayStyle.top ?? '';
      overlayPane.style.left = this.originalOverlayStyle.left ?? '';
      overlayPane.style.margin = this.originalOverlayStyle.margin ?? '';
      overlayPane.style.width = this.originalOverlayStyle.width ?? '';
      overlayPane.style.height = this.originalOverlayStyle.height ?? '';
      overlayPane.style.maxWidth = this.originalOverlayStyle.maxWidth ?? '';
      overlayPane.style.maxHeight = this.originalOverlayStyle.maxHeight ?? '';

      dialogElement.style.width = this.originalDialogStyle.width ?? '';
      dialogElement.style.height = this.originalDialogStyle.height ?? '';
      contentElement.style.maxHeight = this.originalDialogStyle.maxHeight ?? '';
    }
  }

  openCancelAutoRenewDialog(data: any, templateRef: TemplateRef<any>) {
    this.selectedRecord = data;
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
    });
  }

  cancelAutoRenew() {
    this.api.cancelAutoRenew(this.selectedRecord?.RzpSubscriptionId).subscribe({
      next: (_res: any) => {
        this.matDialogRef.close();
        this.LoaderService.hide();
        this.toaster.success('Unsubscribed Successfully..');
        this.getDomain();
        this.loadData();
      },
      error: (_err: any) => {
        this.matDialogRef.close();
        this.LoaderService.hide();
        this.toaster.error('Something went wrong');
      },
    });
  }

  openPlanHistoryDialog(data: any, templateRef: TemplateRef<any>) {
    this.LoaderService.show();
    this.selectedRecord = data;
    this.activeTab = 0;
    this.getSubscriptionDetails();
    this.matDialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      autoFocus: false,
    });
  }

  getSubscriptionDetails() {
    forkJoin({
      subscriptions: this.api.getSubscriptionDetails(this.selectedRecord?.Id),
      addOns: this.api.getAddOnDetails(this.selectedRecord?.Id),
      usageOverview: this.api.getUsageOverview(this.selectedRecord?.Id),
      aiSetting: this.api.getGeneralSetting(this.selectedRecord?.Id, this.aiKeyName)
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ subscriptions, addOns, usageOverview, aiSetting }: any) => {
          if (usageOverview?.Success) {
            this.usageOverviewData = usageOverview?.Data;
          }

          if (subscriptions["Success"] && subscriptions["Data"]) {
            const subData = subscriptions["Data"] as PlanTransaction[];
            const addOnData = (addOns["Success"] && addOns["Data"]) ? addOns["Data"] as AddOnDetail[] : [];
            this.processSubscriptionData(subData, addOnData);
          }
          this.isAIEnabled = aiSetting?.Data?.Value?.toLowerCase() === 'true';
          this.LoaderService.hide();
        },
        error: (error: any) => {
          this.LoaderService.hide();
          this.toaster.error('Error fetching plan history details.', error);
        }
      });
  }

  private processSubscriptionData(allTransactions: PlanTransaction[], allAddOns: AddOnDetail[]): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.currentPlan = allTransactions.find(x =>
      x.TransactionTypeId === 2 && new Date(x.TransactionExpiryDate) >= today
    ) || null;

    if (this.currentPlan) {
      this.currentPlan.daysRemaining = this.calculateDaysRemaining(this.currentPlan.TransactionExpiryDate);
    }

    this.previousPlan = allTransactions.filter(x =>
      x.TransactionTypeId === 2 && (!this.currentPlan || x.Id !== this.currentPlan.Id)
    );

    this.mapWhatsAppToPlans(allTransactions);
    this.mapAddOnsToPlans(allAddOns);

    this.cd.detectChanges();
  }

  private mapWhatsAppToPlans(allTransactions: PlanTransaction[]): void {
    const whatsappTransactions = allTransactions.filter(x => x.TransactionTypeId === 1);

    if (whatsappTransactions.length > 0) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (this.currentPlan) {
        this.currentPlan.whatsappStatus = this.getWhatsappStatusForPlan(whatsappTransactions, this.currentPlan, today, 'current');
      }

      this.previousPlan.forEach(plan => {
        plan.whatsappStatus = this.getWhatsappStatusForPlan(whatsappTransactions, plan, today, 'previous');
      });
    }
  }

  private getWhatsappStatusForPlan(whatsappTransactions: PlanTransaction[], plan: PlanTransaction, today: Date, type: 'current' | 'previous'): 'Active' | 'Expired' | null {
    const planStart = new Date(plan.Date);
    planStart.setHours(0, 0, 0, 0);
    const planEnd = new Date(plan.TransactionExpiryDate);
    planEnd.setHours(0, 0, 0, 0);

    // Find if any WhatsApp plan belongs to this period
    const matchingWhatsapp = whatsappTransactions.find(w => {
      const wExpiry = new Date(w.TransactionExpiryDate);
      wExpiry.setHours(0, 0, 0, 0);
      return type === 'current' ? wExpiry >= planStart : (wExpiry >= planStart && wExpiry <= planEnd);
    });

    if (matchingWhatsapp) {
      const wExpiry = new Date(matchingWhatsapp.TransactionExpiryDate);
      wExpiry.setHours(0, 0, 0, 0);
      if (type === 'current' && this.currentPlan) {
        this.currentPlan.whatsAppExpiryDate = wExpiry.toString();
      }
      const currentStatus = wExpiry >= today ? 'Active' : 'Expired';
      return type === 'current' ? currentStatus : 'Expired';
    }
    return null;
  }

  private mapAddOnsToPlans(allAddOns: AddOnDetail[]): void {
    if (this.currentPlan) {
      this.currentPlan.addOns = this.getAddOnsForPlan(allAddOns, this.currentPlan);
    }
    this.previousPlan.forEach(plan => {
      plan.addOns = this.getAddOnsForPlan(allAddOns, plan);
    });
  }

  private getAddOnsForPlan(allAddOns: AddOnDetail[], plan: PlanTransaction): AddOnDetail[] {
    if (!allAddOns) return [];

    const planUsage = Array.isArray(this.usageOverviewData)
      ? this.usageOverviewData.find(u => u.TransactionId === plan.Id)
      : null;

    const planStart = new Date(plan.Date);
    planStart.setHours(0, 0, 0, 0);
    const planEnd = new Date(plan.TransactionExpiryDate);
    planEnd.setHours(0, 0, 0, 0);

    const filtered = allAddOns
      .filter(addon => {
        const comparisonDate = new Date(addon.ExpiryDate ?? addon.AddOnDate);
        comparisonDate.setHours(0, 0, 0, 0);
        return comparisonDate >= planStart && comparisonDate <= planEnd;
      })
      .map(addon => ({
        ...addon,
        TypeName: addon.AddOnTypes?.TypeName ?? 'Other'
      }));


    // Aggregate by TypeName
    const aggregated = filtered.reduce((acc: { [key: string]: AddOnDetail }, curr) => {
      const typeName = curr.TypeName || 'Other';
      if (!acc[typeName]) {
        acc[typeName] = { ...curr };
      } else {
        acc[typeName].AddOnCount += curr.AddOnCount;
      }
      return acc;
    }, {});

    return Object.values(aggregated).map(addon => {
      let usedCount = 0;
      if (planUsage) {
        if (addon.TypeName === 'User') usedCount = planUsage.TotalAddonUsers;
        else if (addon.TypeName === 'Location') usedCount = planUsage.TotalLocations;
        else if (addon.TypeName === 'Patients') usedCount = planUsage.TotalPatients;
        else if (addon.TypeName === 'Storage') usedCount = planUsage.TotalStorage;
      }
      return {
        ...addon,
        addonUsage: usedCount
      };
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  calculateDaysRemaining(expiryDate: string): number {
    if (!expiryDate) return 0;

    const expiry = new Date(expiryDate);
    const today = new Date();

    // Create date-only objects using year, month, and day components
    const expiryDateOnly = new Date(expiry.getFullYear(), expiry.getMonth(), expiry.getDate());
    const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Calculate difference in days
    const diffDays = Math.floor((expiryDateOnly.valueOf() - todayDateOnly.valueOf()) / (1000 * 60 * 60 * 24));

    return Math.max(diffDays, 0);
  }

  onCurrencyChange(event: any): void {
    this.selectedCurrencyId = event.value;
    if (this.plans && this.plans.length > 0) {
      const currencyCode = this.getCurrencyCodeById(this.selectedCurrencyId);
      this.updatePlanPrices(currencyCode);
    }
  }

  getCurrencyCodeById(currencyId: number): string {
    const currency = this.currencyMap.find((c: any) => c.Id === currencyId);
    return currency ? currency.CurrencyCode : 'INR';
  }

  getCurrencySymbolById(currencyId: number): string {
    const currency = this.currencyMap.find((c: any) => c.Id === currencyId);
    return currency ? currency.CurrencySymbol : '₹';
  }

  copyToClipboard(text: string) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        this.toaster.success('Copied to clipboard');
      }).catch(err => {
        console.error('Could not copy text: ', err);
      });
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.toaster.success('Copied to clipboard');
    }
  }

  getPlanPrice(planId: number, isYearly: boolean): string {
    const currencyCode = this.getCurrencyCodeById(this.selectedCurrencyId);
    const planPrice = this.planPrices[planId];

    if (!planPrice) return '0';

    const priceType = isYearly ? 'annual' : 'monthly';
    return planPrice[currencyCode]?.[priceType] ?? '0';
  }

  updatePlanPrices(currencyCode: string): void {
    this.plans = this.plans.map(plan => ({
      ...plan,
      monthlyPrice: this.planPrices[plan.id]?.[currencyCode]?.monthly ?? plan.monthlyPrice,
      annualPrice: this.planPrices[plan.id]?.[currencyCode]?.annual ?? plan.annualPrice
    }));
  }

  getCurrency(): void {
    this.api.getCountry().subscribe({
      next: (res: any) => {
        if (!res?.Success || !Array.isArray(res.Data)) return;

        this.currencyMap = res.Data?.filter((c: any) => c.CurrencyCode === 'INR' || c.CurrencyCode === 'USD');

        if (!this.currencyMap.length) return;

        const defaultcurrency = this.currencyMap.find((c: any) => c.Id === 1);
        this.selectedCurrencyId = defaultcurrency.Id;
      },
      error: (err: any) => console.error(err)
    });
  }

  get ruleControls(): FormArray {
    return this.creditRuleForm.get('rules') as FormArray;
  }
  creditRuleInit() {
    this.creditRuleForm = this.FormBuilder.group({
      rules: this.FormBuilder.array([])
    });
  }
  private buildRules(data: any[]) {
    const arr = this.FormBuilder.array(
      (data || []).map(x =>
        this.FormBuilder.group({
          Id: [x.Id],
          Name: [x.Name],
          CreditValue: [x.CreditValue, [Validators.required, Validators.min(0)]]
        })
      )
    );
    this.creditRuleForm.setControl('rules', arr);
  }
  async getCreditRules() {
    this.loading = true;
    this.LoaderService.show();
    const response: any = await firstValueFrom(this.api.getCreditRule(this.selectedUser.Id));
    if (response.Success) {
      this.buildRules(response?.Data);
      this.loading = false;
      this.LoaderService.hide();
    }
    else {
      this.loading = false;
      this.LoaderService.hide();
    }
  }
  async openCreditRuleDialog(dataItem: any) {
    this.selectedUser = dataItem;
    this.creditRuleInit();
    await this.getCreditRules();
    this.dialog.open(this.creditRuleDialog, {
      disableClose: true,
      panelClass: 'popup_custom_width_small',
      autoFocus: false,
      width: '500px'
    });
  }
  UpdateMality() {
    if (this.creditRuleForm.invalid) return;
    this.loading = true;

    var payload = {
      CompanyId: this.selectedUser.Id,
      modalityList: this.creditRuleForm.value.rules
    }
    console.log(payload);

    this.api.updateCreditRules(payload).subscribe((res: any) => {
      if (res.Success) {
        this.toaster.success('Credit Rules updated successfully');
      } else {
        this.toaster.error('Failed to update Credit Rules');
      }
      this.loading = false;
      this.close();
    });

    setTimeout(() => {
      this.loading = false;
      this.close();
    }, 1000);
  }

  CreateDomain(companyId: any) {
    this.api.createDomain(companyId).subscribe({
      next: () => {
        this.getDomain();
        this.loadData();
      },
      error: () => {
        this.getDomain();
        this.loadData();
      }
    });
  }

}